import React,{useEffect} from "react";
import { useParams } from "react-router";
import DemoRegister from "../../components/BookDemo/google/DemoRegister";
import DemoSchedule from "../../components/BookDemo/google/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/google/SuccessMessage";
import { initGA, initGtm } from "../../helpers/CampaignEvents";

const GoogleBookaDemo = () => {
  const { component } = useParams();

  useEffect(() => {
    initGA()
  }, [])
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">
          {component === "schedule-demo" ? (
            <DemoSchedule />
          ) : component === "success" ? (
            <SuccessMessage />
          ) : (
            <DemoRegister subject={component} />
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleBookaDemo;
